import axiosPost from "./axiosPost";

export const RNPSProgramaDel = async (credentials, data) => {
    const body = {
        service: "RNPSProgramaDel",
        params: {
            rnpsProgramaId: data?.id,
        },
    };
    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
